import { IGatsbyImageData } from "gatsby-plugin-image";

export const cleanMediaPath = (src: string): string =>
  src.replace(/^\/?api\/media\//, "");

export const cleanApiPath = (src: string): string =>
  src.replace(/^\/?api\//, "");

export const getImageFromGatsby = (
  src: string | undefined,
  nodes: {
    relativePath: string;
    childImageSharp?: {
      gatsbyImageData: IGatsbyImageData;
    };
  }[],
): IGatsbyImageData | null => {
  if (!src) {
    return null;
  }

  const cleaned = cleanMediaPath(src);
  const match = nodes.find((n) => n.relativePath === cleaned);

  const image = match?.childImageSharp?.gatsbyImageData;
  return image || null;
};
